import { defineMessages } from 'react-intl-next';
export var commentMessages = defineMessages({
  addCommentOnMedia: {
    id: 'fabric.editor.addCommentOnMedia',
    defaultMessage: 'Add comment',
    description: 'Add a comment for this media (image/video)'
  },
  viewCommentsOnMedia: {
    id: 'fabric.editor.viewCommentOnMedia',
    defaultMessage: 'View comments',
    description: 'View a existing comment for this media (image/video)'
  },
  viewAndAddCommentsOnMedia: {
    id: 'fabric.editor.viewAndAddCommentsOnMedia',
    defaultMessage: 'View and add comments',
    description: 'View and add comments for this image'
  }
});